import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const StyledReportRow = styled.div(
  props => css`
    margin-bottom: ${layout.measurements.spacing050};
    margin-top: ${layout.measurements.spacing075};
    padding: 0 ${layout.measurements.spacing100};
    border-radius: 8px;
    color: ${props.theme.text.secondary};
    background: ${props.theme.colors.base100};
  `
);

export const StyledAlternativePricesArea = styled.div`
  background: ${props => props.theme.colors.base100};
  background-color: rgba(0, 0, 0, 0.03);
  padding: 0.75rem;
  padding-top: 0;
`;

export const StyledInfoRow = styled.div`
  background: ${props => props.theme.colors.base100};
  background-color: rgba(0, 0, 0, 0.03);
`;

export const StyledExpandButtonWrapper = styled.div`
  align-items: stretch;
  min-width: ${layout.measurements.spacing200};
`;
